module.exports = __webpack_public_path__ + "static/extensions-5a071b62631590915838ae913acc3f29.png";